module.exports = __webpack_public_path__ + "img/umbrella.0d6460ed.svg";